import axios from 'axios'
const getAjax = ({url, method, headers, data}) =>{
    return axios(url,{
        method:method ||'POST',
        data,
        headers:{
            'content-type':'application/json'
        }
    })
}

export default getAjax